const context = require.context(
    '.',
    false,
    /^\.\/(?!_)(?!index\.js$)[^/]+\.js$/
);

const posts = context
    .keys()
    .map((key) => context(key).default)
    .filter(Boolean);

const sortedPosts = [...posts].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
);

const numberedPosts = sortedPosts.map((post, index) => ({
    ...post,
    number: sortedPosts.length - index,
}));

export default numberedPosts;